import React, { useContext, useState } from 'react';

import { TextContext } from '@/utils/contexts/TextContext';
import LetterContentWrapper from '@/views/pages/Letter/elements/LetterContentWrapper';

const LetterVersionsWrapper = ({ currentLeftMode, setCurrentLeftMode, currentRightMode, setCurrentRightMode }) => {

	const { contextState } = useContext(TextContext);

	const [ leftModes ] = useState([ 'originalDoc' ]);
	const [ rightModes ] = useState([ 'simplifiedDoc', 'finalDoc' ]);
	const [ combinedNodes ] = useState([ 'simplifiedDoc', 'finalDoc' ]);

	return (
		<section className='letter__versions'>
			{!contextState.isMobile ? (
				<>
					<LetterContentWrapper 
						modes={ leftModes } 
						currentMode={ currentLeftMode } 
						setCurrentMode={ setCurrentLeftMode } 
					/>
					<div className='letter__versions--spacer' />
					<LetterContentWrapper 
						modes={ rightModes } 
						rightModes={ rightModes }
						currentMode={ currentRightMode } 
						setCurrentMode={ setCurrentRightMode } 
					/>
				</>
			) : (
				<LetterContentWrapper 
					modes={ combinedNodes }
					currentMode={ currentRightMode } 
					setCurrentMode={ setCurrentRightMode } 
				/>
			)}
		</section>
	);
};

export default LetterVersionsWrapper;